import React from "react";
import CarouselWidget from '../component';
import BaseWidget, { WidgetState } from "../../../widgets/BaseWidget";
import { WidgetType } from "../../../constants/WidgetConstants";
import { ValidationTypes } from "../../../constants/WidgetValidation";
import { isAutoLayout } from "utils/autoLayout/flexWidgetUtils";
import { Alignment } from "@blueprintjs/core";
import { LabelPosition } from "components/constants";
import { EventType, type ExecutionResult } from "constants/AppsmithActionConstants/ActionConstants";
import {GRID_DENSITY_MIGRATION_V1} from "widgets/constants";
import panelConfig from "./propertyConfig/PanelConfig";
import styleConfig from "./propertyConfig/styleConfig";

import {
  isAutoHeightEnabledForWidget
} from "widgets/WidgetUtils";
import type { DerivedPropertiesMap } from "utils/WidgetFactory";
import {Stylesheet} from "../../../entities/AppTheming";
import _ from "lodash";
import {__DEP_CFG__} from "../../../workers/common/DependencyMap/configUtils";
class Carousel extends BaseWidget<any, WidgetState> {
  constructor(props: any) {
    super(props);
  }
  static getPropertyPaneEventConfig() {
    return super.getWidgetEvents('subTableWidget');
  }
  static getPropertyPaneContentConfig() {
    return [
      {
        sectionName: "标签",
        children: [
          {
            helpText: "Sets the label text of the widget",
            propertyName: "label",
            label: "文本",
            controlType: "INPUT_TEXT",
            placeholderText: "Enter label text",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            helpText: "Sets the label position of the widget",
            propertyName: "labelPosition",
            label: "位置",
            controlType: "ICON_TABS",
            fullWidth: true,
            hidden: isAutoLayout,
            options: [
              { label: "自动", value: LabelPosition.Auto },
              { label: "居左", value: LabelPosition.Left },
              { label: "居上", value: LabelPosition.Top },
            ],
            defaultValue: LabelPosition.Top,
            isBindProperty: false,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            helpText: "Sets the label alignment of the widget",
            propertyName: "labelAlignment",
            label: "对齐方式",
            controlType: "LABEL_ALIGNMENT_OPTIONS",
            fullWidth: false,
            options: [
              {
                startIcon: "align-left",
                value: Alignment.LEFT,
              },
              {
                startIcon: "align-right",
                value: Alignment.RIGHT,
              },
            ],
            isBindProperty: false,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
            hidden: (props: any) =>
              props.labelPosition !== LabelPosition.Left,
            dependencies: ["labelPosition"],
          },
          {
            helpText:
              "Sets the label width of the widget as the number of columns",
            propertyName: "labelWidth",
            label: "宽度（以列为单位）",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 0,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            },
          },
        ],
      },
      {
        sectionName: "表格列",
        children: [
          {
            //helpText: "Bind data from an API using {{}}",
            propertyName: "tableColumns",
            label: "",
            controlType: "TABLE_COLUMNS",
            isBindProperty: true,
            isTriggerProperty: true,
            dependencies: ['tableData'],
            defaultPropsColumns: {
              fileSize: 1,
              fileCount: 10
            },
            panelConfig: panelConfig as any
          }
        ]
      },
      {
        sectionName: "数据",
        children: [
          {
            helpText: "",
            propertyName: "jsValue",
            label: "默认值",
            controlType: "INPUT_TEXT",
            placeholderText: '',
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false
          }

        ]
      },
      {
        sectionName: "验证",
        children: [
          {
            propertyName: "isRequired",
            label: "是否必填",
            helpText: "Makes input to the widget mandatory",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            helpText:
              "Sets the label width of the widget as the number of columns",
            propertyName: "maxCount",
            label: "最多可添加行数",
            controlType: "NUMERIC_INPUT",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            min: 0,
            validation: {
              type: ValidationTypes.NUMBER,
              params: {
                natural: true,
              },
            },
          },
        ],
      },
      {
        sectionName: "一般",
        children: [
          {
            helpText: "Show help text or details about current selection",
            propertyName: "labelTooltip",
            label: "提示",
            controlType: "INPUT_TEXT",
            placeholderText: "",
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          },
          {
            helpText: "Controls the visibility of the widget",
            propertyName: "isShowNo",
            label: "是否隐藏序号",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            helpText: "Controls the visibility of the widget",
            propertyName: "isPropAdd",
            label: "是否隐藏添加行",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            helpText: "Controls the visibility of the widget",
            propertyName: "isPropOperation",
            label: "是否隐藏操作列",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            helpText: "Controls the visibility of the widget",
            propertyName: "isVisible",
            label: "是否可见",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            propertyName: "isDisabled",
            label: "是否禁用",
            helpText: "Disables input to this widget",
            controlType: "SWITCH",
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
        ],
      },
      {
        sectionName: "分页",
        children: [
          {
            propertyName: "isPagination",
            label: "启用分页",
            helpText: "Controls the visibility of the tab",
            controlType: "SWITCH",
            useValidationMessage: true,
            isJSConvertible: true,
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.BOOLEAN },
          },
          {
            helpText: "",
            propertyName: "pageSizeOptions",
            label: "每页多少条数据",
            controlType: "INPUT_TEXT",
            placeholderText: '10,20,50',
            isBindProperty: true,
            isTriggerProperty: false,
            validation: { type: ValidationTypes.TEXT },
          }
        ]
      },
    ];
  }
  static getPropertyPaneStyleConfig() {
    return [
      ... styleConfig
    ];
  }
  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      value: `{{ this.value }}`,
      getValue: `{{ this.value }}`,
      tableData: `{{ this.value }}`,
      currentItem: `{{ this.currentItem }}`,
      // 判断是否有未保存的记录
      isValid: `{{this.isSaveComplete}}`,
    };
  }
  static getMetaPropertiesMap(): Record<string, any> {
    return {
      value: [],
      isFirst: false,
      currentItem: {},
      currPage: 1,
      pageSize: 10
    };
  }

  static getDefaultPropertiesMap(): Record<string, any> {
    return {
      jsValue: null
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "{{appsmith.theme.boxShadow.appBoxShadow}}",
      labelTextColor: "{{appsmith.theme.form.label.fontColor}}",
      labelTextSize: "{{appsmith.theme.form.label.fontSize}}",
      labelStyle: "{{appsmith.theme.form.label.fontStyle}}",
      accentColor: "{{appsmith.theme.colors.primaryColor}}",
      opBtnBgColor: "{{appsmith.theme.colors.primaryColor}}",
      opBtnColor: "{{appsmith.theme.colors.primaryColor}}",
      newBtnColor: "{{appsmith.theme.colors.primaryColor}}",
      newBtnBgColor: "{{appsmith.theme.colors.primaryColor}}",
      opBtnType: "SECONDARY",
      newBtnType: "TERTIARY",
    };
  }
  initCellSelectOptions = ()=>{
    const {tableColumns, tableColumnsMap, tableData, widgetName} = this.props;
    let columnsMap:Record<string, any> = {};

    const select = _.filter(_.values(tableColumns), { columnType: 'select'});
    _.each(select, i=>{
      let selectLabel = `${widgetName}.${i.id}.label`,
        selectValue = `${widgetName}.${i.id}.value`;
      columnsMap[selectValue] = [];
      _.each(tableData, j=>{
        if(j[selectValue]&&!tableColumnsMap?.[selectValue]){
          columnsMap[selectValue].push({
            [selectLabel]: j[selectLabel] || j[selectValue],
            [selectValue]: j[selectValue]
          })
        }
      })
    })
    if(tableColumnsMap){
      columnsMap = {
        ...columnsMap,
        ...tableColumnsMap
      }
    }
    if(!_.isEmpty(columnsMap)&&!_.isEmpty(tableData)&&!_.isEqual(columnsMap, tableColumnsMap)){
      this.props.updateWidgetMetaProperty("tableColumnsMap", columnsMap);
    }

  }
  onDeleteClick = (eventObj:any, item:any)=>{
    this.props.updateWidgetMetaProperty("currentItem", item);
    super.executeAction({
      triggerPropertyName: "onClick",
      dynamicString: eventObj||this.props.onDelete,
      event: {
        type: EventType.ON_CLICK
      },
    });
  }
  paginationChange = (currPage:any, pageSize:any)=>{
    const {pushBatchMetaUpdates, commitBatchMetaUpdates} = this.props;
    if (!this.props.isDirty) {
      pushBatchMetaUpdates('isDirty', true);
    }
    pushBatchMetaUpdates('currPage', currPage);
    pushBatchMetaUpdates('pageSize', pageSize);
    commitBatchMetaUpdates();
  }
  getPageView() {
    let _defaultValue = this.props.tableData;
    this.initCellSelectOptions();
    return (
      <>
        <CarouselWidget {...this.props} value={_defaultValue} widgetId={this.props.widgetId} key={this.props.widgetId} isDynamicHeightEnabled={isAutoHeightEnabledForWidget(this.props as any)}
          labelWidth={this.getLabelWidth()} compactMode={!((this.props.bottomRow - this.props.topRow) / GRID_DENSITY_MIGRATION_V1 > 1)}
          onChange={this.onChange} onValueChange={this.onValueChange} onOptionChange={this.onOptionChange} onSaveCompleteChange={this.onSaveCompleteChange}
                        subCellEvents={this.subCellEvents} upTableColumnsMap={this.upTableColumnsMap} onDeleteClick={this.onDeleteClick}
                        paginationChange={this.paginationChange} />
      </>
    )
  }
  onSaveCompleteChange= (val: any) => {
    this.props.updateWidgetMetaProperty("isSaveComplete", val);
  };
  onValueChange = (updatedValue: any) => {
    this.props.updateWidgetMetaProperty("value", updatedValue);
    if (this.props.onChange) {
      super.executeAction({
        triggerPropertyName: "onChange",
        dynamicString: this.props.onChange,
        event: {
          type: EventType.ON_CHANGE,
          callback: this.handleActionResult,
        },
      });
    }
  };
  subCellEvents = (eventObj:any, path:string)=>{
    super.executeAction({
      triggerPropertyName: "onDropdownOpen",
      dynamicString: eventObj,
      event: {
        type: EventType.ON_OPTION_CHANGE
      },
    });
  }
  upTableColumnsMap = (upRecord:any={})=>{
    this.props.updateWidgetMetaProperty("tableColumnsMap", {
      ...this.props.tableColumnsMap,
      ...upRecord
    });
  }

  onOptionChange = (onOptionChangeEvent: any, record:Record<string, unknown>={}) => {
    this.props.updateWidgetMetaProperty("currentItem", record.currentItem);
    let event=onOptionChangeEvent;
    if (event) {
      super.executeAction({
        triggerPropertyName: "onOptionChange",
        dynamicString: event,
        event: {
          type: EventType.ON_OPTION_CHANGE,
          callback: this.handleActionResult,
        },
        globalContext: {
          params: JSON.stringify(record.params),
          _mark: 'widgetParams'
        }
      });
    }
  };

  handleActionResult = (result: ExecutionResult) => { };
  onChange = () => {
    if (this.props.onChange) {
      super.executeAction({
        triggerPropertyName: "onChange",
        dynamicString: this.props.onChange,
        event: {
          type: EventType.ON_CHANGE,
          callback: this.handleActionResult,
        },
      });
    }
  };

  static getWidgetType(): WidgetType {
    return 'SUB_TABLE_WIDGET';
  }
}

export default Carousel;
